import { supabase } from "@/integrations/supabase/client";

export interface UserBootstrap {
  roles: string[];
  feature_flags: Record<string, boolean>;
}

const cache = new Map<string, Promise<UserBootstrap>>();

const EMPTY: UserBootstrap = { roles: [], feature_flags: {} };

export const fetchUserBootstrap = (userId: string): Promise<UserBootstrap> => {
  const existing = cache.get(userId);
  if (existing) return existing;

  const promise = (async () => {
    try {
      const { data, error } = await supabase.rpc("get_user_bootstrap" as any, {
        _user_id: userId,
      });
      if (error || !data) return EMPTY;
      const payload = data as any;
      return {
        roles: Array.isArray(payload.roles) ? payload.roles : [],
        feature_flags:
          payload.feature_flags && typeof payload.feature_flags === "object"
            ? payload.feature_flags
            : {},
      };
    } catch {
      return EMPTY;
    }
  })();

  cache.set(userId, promise);
  return promise;
};

export const invalidateUserBootstrap = (userId?: string) => {
  if (userId) cache.delete(userId);
  else cache.clear();
};
